import { setActiveCategory } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = null;

export default createReducer(
  [forAction(setActiveCategory, identityPayload)],
  initialState,
);
